// On-site facts — Yes / No / Unsure segmented answers (+ people count when Yes).
import { ONSITE_FACTS, onsiteAnswer, onsitePatch } from "../_quoteHelpers";

const OPTS = [
  ["yes", "Yes", "#15803d"],
  ["no", "No", "#dc2626"],
  ["unsure", "Unsure", "#b45309"],
];

function Tri({ value, onChange, testid }) {
  return (
    <div className="qb-tri" role="radiogroup" data-testid={testid}>
      {OPTS.map(([k, label, col]) => {
        const on = value === k;
        return (
          <button key={k} type="button" role="radio" aria-checked={on} onClick={() => onChange(on ? null : k)}
            data-testid={`${testid}-${k}`} className={`qb-tri-btn${on ? " on" : ""}`} style={on ? { "--tri": col } : undefined}>
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default function OnSiteFacts({ delivery = {}, onPatch, testidPrefix = "delivery-onsite" }) {
  const people = Number(delivery.peopleOnSite) || 0;
  return (
    <>
      {ONSITE_FACTS.map((f) => {
        const a = onsiteAnswer(delivery, f.key);
        return (
          <div key={f.key} className="qb-tri-row" data-testid={`${testidPrefix}-${f.key}`}>
            <span className="qb-tri-label">{f.label}</span>
            {f.key === "people" && a === "yes" && (
              <input type="number" min="1" step="1" value={people || ""} aria-label="How many people"
                onChange={(e) => onPatch({ peopleOnSite: Math.max(1, Number(e.target.value) || 1) })}
                className="t2-input t2-mono qb-tri-count" data-testid={`${testidPrefix}-people-count`} />
            )}
            <Tri value={a} onChange={(v) => onPatch(onsitePatch(delivery, f.key, v))} testid={`${testidPrefix}-${f.key}-answer`} />
          </div>
        );
      })}
    </>
  );
}
